import { render, staticRenderFns } from "./index.vue?vue&type=template&id=212132ba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=212132ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212132ba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSharedDialogsDialogMBlur: require('/app/components/ui/shared/dialogs/DialogMBlur.vue').default,AuthRegister: require('/app/components/auth/register/index.vue').default})
